import useModalReducer from "hooks/useModal";
import { useCallback, useState } from "react";
import { ViewClaimsModal } from "../ViewClaimsModal";
import { ClaimsTable } from "../ClaimsTable";
import { useEffect } from "react";
import { centreOptions } from "constants";
import { claimsTableModalEmitter } from "../ClaimsTable/config";

const pettyCashTableFilters = [
	{
		filterName: "date_from",
		operator: "contains",
		placeholder: "Date",
		type: "date",
		label: "Date From",
	},
	{
		filterName: "date_to",
		operator: "contains",
		placeholder: "Date",
		type: "date",
		label: "Date To",
	},
	{ filterName: "is_petty_cash", operator: "contains", type: "hidden", value: true },
	{ filterName: "staff_name", operator: "contains", placeholder: "Staff Name" },
	{
		filterName: "status",
		operator: "contains",
		label: "Status",
		type: "select",
		options: [
			{ value: null, label: "All" },
			{ value: "pending", label: "Pending" },
			{ value: "approved", label: "Approved" },
			{ value: "rejected", label: "Rejected" },
			{ value: "paid", label: "Paid" },
		],
	},
	{
		filterName: "centre",
		operator: "contains",
		label: "Centre",
		type: "select",
		options: [{ value: null, label: "All" }, ...centreOptions],
	},
];

const PettyCashClaimsPage = () => {
	const { state, dispatch, actions } = useModalReducer();

	const showModal = useCallback((row) => {
		dispatch({
			type: actions.OPEN,
			payload: row,
		});
	}, []);

	const hideModal = useCallback(() => {
		dispatch({ type: actions.CLOSE });
	}, []);

	useEffect(() => {
		const unbind = claimsTableModalEmitter.on("showModal", showModal);
		return unbind;
	}, [showModal]);

	const [refetchCheck, setRefetchCheck] = useState(false);

	const refetch = useCallback(() => setRefetchCheck((prev) => !prev), []);

	return (
		<div className="relative content">
			<ViewClaimsModal state={state} showModal={showModal} hideModal={hideModal} self={true} payoutAction approveActions refetch={refetch} />
			<ClaimsTable showModal={showModal} parentRefetchCheck={refetchCheck} filters={pettyCashTableFilters} title="Petty Cash Claims" />
		</div>
	);
};

export default PettyCashClaimsPage;
